import _ from 'lodash';
import React from 'react';

import {
  authUtil,
  routeDirectory
} from 'modules';

import { useNavigate } from 'react-router-dom';
import * as dataService from './dataService';



export const RootActivity: React.FC = () => {
  const authState = authUtil.useAuthState();
  const navigate = useNavigate();
  const queryTuple = dataService.useQuery(authState);



  React.useEffect(() => {
    if (authState.status === 'noAttemptMade') {
      return;
    }

    if (authState.status === 'notLoggedIn') {
      navigate(routeDirectory.auth.logIn.path());
      return;
    }

    if (!queryTuple.called || queryTuple.loading) {
      return;
    }

    // Super admins should immediately be redirected to the reconciliation report.
    if (queryTuple.data.isSuperAdmin || _.includes(queryTuple.data.permissions, 'platform_godMode')) {
      navigate(routeDirectory.admin.root.path());
      return;
    }

    // The common case for customers. Will only have 1 store
    if (queryTuple.data.storeIds.length === 1) {
      navigate(routeDirectory.partner.storeDetail.path(_.first(queryTuple.data.storeIds) ?? ''));
    } else if (queryTuple.data.storeIds.length > 1) {
      // If the user has access to more than 1 store, they need to pick
      navigate(routeDirectory.partner.stores.path());
    } else {
      // The user has no stores
      navigate(routeDirectory.noStores.path());
    }
  }, [authState.status, navigate, queryTuple]);



  return (
    <div />
  );
};
